var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-16 text-center mt-16"},[_vm._v("请重新登陆")])
}
var staticRenderFns = []

export { render, staticRenderFns }